export default __webpack_public_path__ + "static/pic3-b77c55a897fbefd31038152d64a409e2.webp";